import { EditOutlined } from '@ant-design/icons';
import { plainToInstance } from 'class-transformer';
import { useEdit } from 'hooks/useEdit';
import { useState } from 'react';

export const customEditAction = action => {
    return props => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;

        // eslint-disable-next-line no-unused-vars
        const {
            CustomComponent,
            service,
            title,
            config,
            entity,
            onClose,
            actionType,
        } = action;

        const value = 'customEdit';

        const label = 'Edit';

        const [openModal, setOpenModal] = useState(false);

        const handleOpenModal = () => {
            setOpenModal(true);
        };

        const handleCloseModal = action => {
            setOpenModal(false);
            onClose(action);
        };

        return (
            <>
                <CustomComponent
                    service={service}
                    actionType={actionType}
                    title={title}
                    config={config}
                    entity={entity}
                    defaultValue={params.row}
                    open={openModal}
                    onClose={handleCloseModal}
                />
                <MenuItem
                    key={value}
                    value={value}
                    label={label}
                    icon={<EditOutlined />}
                    onClick={handleOpenModal}
                    {...restProps}
                >
                    {label}
                </MenuItem>
            </>
        );
    };
};
